import axios from 'axios';
import { GetBackendUrlForGlobalFunctions } from '../../../App';
export const SyncFullProntoWorkOrders = () => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.get(GetBackendUrlForGlobalFunctions() + `pronto-work-order`, {
    headers,
  });
};

export const SyncFromProntoApi = (orderCode: string) => {
  const headers = {
    'Content-Type': 'application/json',
  };

  return axios.put(
    GetBackendUrlForGlobalFunctions() +
      `pronto-work-order/sync-from-pronto/${orderCode}`,
    {},
    { headers }
  );
};

export const EditProntoOrders = (obj: any[]) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `pronto-work-order`,
    obj,
    {
      headers,
    }
  );
};
